import { createContext, useContext } from 'react';

const JOTFORM_URL = 'https://form.jotform.com/261696649319069';
const ConsultationContext = createContext();

export function useConsultation() {
  return useContext(ConsultationContext);
}

export function ConsultationProvider({ children }) {
  const setOpen = () => {
    window.open(JOTFORM_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <ConsultationContext.Provider value={{ setOpen }}>
      {children}
    </ConsultationContext.Provider>
  );
}
